// extracted by mini-css-extract-plugin
module.exports = {"comp":"Bundles_comp__3D0v2"};